import React from 'react'
import { useTranslation } from 'react-i18next'
import OptionModal from '../../../../shared/components/OptionModal'
import CreateFolderModal from './CreateFolderModal'
import UploadAdModal from './UploadAdModal'
import RenameAdModal from './RenameAdModal'
import DeleteAdsModal from './DeleteAdsModal'
import PreviewAdModal from './PreviewAdModal'

// Single mount point for every Ad Library modal. Driven by useAdLibraryModals
// state ({ modal, payload }) and wired to the Redux action handlers passed in.
const AdLibraryModals = ({ modal, payload, close, actions, folders = [], selectedTag = null, uploading = false, folderSubmitting = false, categories = [], loadingCategories = false, isSuperUser = false}) => {
  const { t } = useTranslation()
  const {
    createFolder,
    renameFolder,
    deleteFolders,
    uploadAds,
    renameAd,
    deleteAds,
  } = actions

  const run = (fn) => (...args) => {
    fn(...args)
    close()
  }

  return (
    <>
      <CreateFolderModal
        visible={modal === 'createFolder' || modal === 'renameFolder'}
        folder={modal === 'renameFolder' ? payload && payload.folder : null}
        onSubmit={
          modal === 'renameFolder'
            ? // Pass the current parent_id so the rename doesn't move it to root.
              (name) => renameFolder(payload.folder.id, name, payload.folder.parentId)
            : // Create as a subfolder of the open folder (selectedTag); root when null.
              (name) => createFolder(name, selectedTag)
        }
        onCancel={close}
      />

      <UploadAdModal
        visible={modal === 'uploadAd'}
        folders={folders}
        currentTag={selectedTag}
        uploading={uploading}
        categories={categories}
        loadingCategories={loadingCategories}
        isSuperUser={isSuperUser}
        onSubmit={run((files, meta) => uploadAds(files, meta))}
        onCancel={close}
      />

      <RenameAdModal
        visible={modal === 'renameAd'}
        ad={payload && payload.ad}
        onSubmit={run((name) => renameAd(payload.ad.id, name))}
        onCancel={close}
      />

      <PreviewAdModal visible={modal === 'previewAd'} ad={payload && payload.ad} onCancel={close} />

      {/* Bulk/selection delete: ads and/or folders, each routed to its endpoint. */}
      <DeleteAdsModal
        visible={modal === 'deleteAds'}
        ids={(payload && payload.ids) || []}
        folderIds={(payload && payload.folderIds) || []}
        onConfirm={run((ids, folderIds) => {
          if (ids && ids.length) deleteAds(ids)
          if (folderIds && folderIds.length) deleteFolders(folderIds)
        })}
        onCancel={close}
      />

      {/* Single-folder delete from the folder's "Delete" menu. */}
      <OptionModal
        visible={modal === 'deleteFolder'}
        title={t('Archive folder')}
        body={t('Are you sure you want to archive this folder?')}
        okText={t('Archive')}
        cancelText={t('Cancel')}
        onOk={run(() => deleteFolders([payload.folder.id]))}
        onCancel={close}
        okButtonProps={{ type: 'danger' }}
      />
    </>
  )
}

export default AdLibraryModals
